module.exports = __webpack_public_path__ + "img/center_choose.da360aa7.png";